import * as notificationsStore from './store'

export function notificationsModule({ store }) {
  store.registerModule('notifications', {
    ...notificationsStore,
    namespaced: true,
  })
}
